export interface DemoWord {
  lemma: string
  pos: string
  cefr_level?: string | null
  translation?: string | null
}

export interface DemoExtractResponse {
  detected_language: string
  words: DemoWord[]
}

export interface DemoApiError {
  status: number
  code: string
  detail: string
}

/** Call the anonymous demo endpoint without any auth header. */
export async function callDemoExtract(
  text: string,
  sourceLanguage?: string,
): Promise<DemoExtractResponse> {
  const body: Record<string, string> = { text }
  if (sourceLanguage) body.source_language = sourceLanguage

  const res = await fetch('/api/v1/demo/extract/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  if (!res.ok) {
    let code = 'UNKNOWN'
    let detail = 'Something went wrong.'
    try {
      const json = await res.json()
      if (json.detail && typeof json.detail === 'object') {
        code = json.detail.code ?? code
        detail = json.detail.detail ?? detail
      } else if (typeof json.detail === 'string') {
        detail = json.detail
      }
    } catch {
      // Ignore JSON parse errors — we already have defaults.
    }
    throw { status: res.status, code, detail } satisfies DemoApiError
  }

  return res.json() as Promise<DemoExtractResponse>
}
